import { render, staticRenderFns } from "./add-review-layout.vue?vue&type=template&id=6a5a75b6&"
import script from "./add-review-layout.vue?vue&type=script&lang=js&"
export * from "./add-review-layout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\OSPanel\\domains\\specialty.local\\local\\js\\specialty\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a5a75b6')) {
      api.createRecord('6a5a75b6', component.options)
    } else {
      api.reload('6a5a75b6', component.options)
    }
    module.hot.accept("./add-review-layout.vue?vue&type=template&id=6a5a75b6&", function () {
      api.rerender('6a5a75b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/review/add-review-layout.vue"
export default component.exports